/**
 * Teams Hub API Setup
 * Uses shared @quotech/api bootstrap — see packages/api/src/setupHubApi.ts
 */
import { setupHubApi } from '@quotech/api'

/** Call once in main.tsx before rendering. */
export function setupApi() {
  setupHubApi({ hubName: 'Teams' })
}
